import dotsDotting from '@backrs_ui/common-ui/src/assets/animations/dots-dotting.json';
import lubavLoader from '@backrs_ui/common-ui/src/assets/animations/lubav-loader.json';
import pulsingCircle from '@backrs_ui/common-ui/src/assets/animations/pulsing-circle.json';
export var lottieAnimations = {
    lubavLoader: lubavLoader,
    dotsDotting: dotsDotting,
    pulsingCircle: pulsingCircle,
};
